import { render, staticRenderFns } from "./add-basic-information.vue?vue&type=template&id=10d315f5&scoped=true&"
import script from "./add-basic-information.vue?vue&type=script&lang=js&"
export * from "./add-basic-information.vue?vue&type=script&lang=js&"
import style0 from "./add-basic-information.vue?vue&type=style&index=0&id=10d315f5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d315f5",
  null
  
)

export default component.exports